import { optionName } from './stationAdapter';

/** "Database Taxonomy": active fuel options per category, from GET admin/fuel-options. */
export default function TaxonomySection({ groups, loading, error }) {
  return (
    <section
      aria-labelledby="taxonomy-heading"
      className="bg-surface-container-lowest rounded-xl border border-outline-variant/30 shadow-xs p-5"
    >
      <h2 id="taxonomy-heading" className="text-lg font-bold text-primary">
        Database Taxonomy: <code className="font-data-mono text-base">fuelOption</code> &amp; Subtypes
      </h2>
      <p className="text-xs text-on-surface-variant mb-4">Active fuel options per category, with the unit prices are entered in.</p>

      {error ? (
        <p className="text-sm text-error">{error.message}</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3">
          {loading
            ? Array.from({ length: 5 }, (_, i) => <div key={i} className="h-32 rounded-lg bg-surface-container-low animate-pulse" />)
            : groups.map((group) => (
                <div key={group.key} className="p-3 bg-surface-container-low rounded-lg flex flex-col gap-1.5">
                  <div className="flex items-center justify-between gap-2">
                    <h3 className={`text-sm font-bold ${group.key === 'ev' ? 'text-secondary' : 'text-on-surface'}`}>{group.label}</h3>
                    {group.unit && (
                      <span className="font-data-mono text-[10px] text-on-surface-variant bg-surface-container px-1 rounded">unit: {group.unit}</span>
                    )}
                  </div>
                  <ul className="text-xs text-on-surface-variant space-y-0.5">
                    {group.options.map((o) => (
                      <li key={o.id}>• {optionName(o)}</li>
                    ))}
                  </ul>
                </div>
              ))}
        </div>
      )}
    </section>
  );
}
